<template>
  <base-nav
      container-classes="container-fluid"
      class="navbar-top navbar-expand"
      :class="{'navbar-dark': type === 'default'}"
  >
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
      <li class="nav-item d-sm-none">
        <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
        <a href="javascript:void(0)" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm  font-weight-bold">{{ ($root.user !== null)?$root.user.name:'' }} <i class="ni ni-bold-down"/></span>
            </b-media-body>
          </b-media>
        </a>

        <template>
          <b-dropdown-item v-if="$router.resolve({name:'profileEdit'}).path !== '/'" :to="{name:'profileEdit'}">
            <i class="ni ni-single-02"></i>
            <span>{{ trans.get('hi.profile') }}</span>
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item  v-if="$router.resolve({name:'passwordChange'}).path !== '/'" :to="{name:'passwordChange'}">
            <i class="ni ni-settings-gear-65"></i>
            <span>{{ trans.get('hi.change_password') }}</span>
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item @click="logout">
            <i class="ni ni-user-run"></i>
            <span>{{ trans.get('hi.logout') }}</span>
          </b-dropdown-item>

        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ''
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    async logout(){
      await this.axios.get('/sanctum/csrf-cookie')
          .then(response => {
            this.axios.post('/api/logout')
                .then(response => {
                  this.$cookies.remove('jwt')
                  delete window.axios.defaults.headers.common["Authorization"];
                  this.$root.user = null;
                  window.Laravel.jsPermissions = {};
                  location.href = "/";
                })
                .catch(function (error) {
                  console.error(error);
                });
          });
    }
  }
};
</script>
